import { Button, Card, CardContent, IconButton, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

import { ILanguageBaseWithId } from 'src/types'
import { useStyles } from 'src/components/quantity-types/quantity-types-list/styles'
import { DEFAULT_LANGUAGE_CODE } from '../constants'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  handleUpdate: () => void
  item: ILanguageBaseWithId
  handleDelete: () => void
}

const LanguageItem = ({ item, handleUpdate, handleDelete }: IProps) => {
  const classes = useStyles()

  const isDefaultLang = item.code === DEFAULT_LANGUAGE_CODE
  return (
    <>
      <Card className={classes.cardWrapper}>
        <CardContent className={classes.cardContent}>
          <div className={classes.itemWrapper}>
            <Typography className={classes.cardName} component="h4">
              Language:&nbsp;
              {item.name}
            </Typography>
            <Typography className={classes.cardCategory} component="p">
              Code:&nbsp;
              {item.code}
            </Typography>
          </div>
          <div className={classes.buttonsWrapper}>
            <Button onClick={handleUpdate} disabled={isDefaultLang}>
              <HelperWrapper t={'update-button-text'} />
            </Button>
            <IconButton disabled={isDefaultLang} onClick={handleDelete}>
              <DeleteIcon />
            </IconButton>
          </div>
        </CardContent>
      </Card>
    </>
  )
}

export { LanguageItem }
